var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
//@ts-ignore
import { FixedSizeList } from 'react-window';
import { Draggable } from 'react-beautiful-dnd';
import { IoIosArrowForward } from 'react-icons/io';
import Manager from '@shared/modal/Manager';
import { createDraggableId, DraggableType, parseDraggableId } from '@data/dragAndDrop/types';
import { useNavigate } from 'react-router-dom';
import { extractSheetRowDataFromPath } from '../../data/sheetRow/sheetRow';
import { useLocalData } from '@base/LocalDataContext';
var FINDER_COLUMN_SIZES = {
    width: 280,
    height: 260,
    itemSize: 30,
};
function ClusterRow(_a) {
    var data = _a.data, index = _a.index, style = _a.style;
    var item = data[index];
    if (!item) {
        return null;
    }
    return (React.createElement(FinderCluster, { key: "".concat(item.clusterId).concat(item.path), item: item, index: index, parentId: item.columnId, menuTarget: item.menuTarget, onClick: function (e) { return item.itemClickHandler(item, e); }, menuTargetHandler: item.setMenuTarget, style: style }));
}
export var Column = React.memo(function ColumnInner(_a) {
    var column = _a.column, menuTarget = _a.menuTarget, isUsingPlaceholder = _a.isUsingPlaceholder, providedInnerRef = _a.providedInnerRef, setParentHandler = _a.setParentHandler, expandFinder = _a.expandFinder;
    var navigate = useNavigate();
    var itemClickHandler = function (item, e) {
        if (e.defaultPrevented) {
            return; // do nothing if event is triggered by dnd
        }
        e.preventDefault();
        expandFinder();
        navigate("/sheet/".concat(item.path));
    };
    var _b = __read(extractSheetRowDataFromPath(column.path), 1), columnId = _b[0];
    var setMenuTarget = setParentHandler(columnId);
    var finderColumnsInvalidator = useLocalData().finderColumnsInvalidator; // keep it here so it forces re-render
    var clusterItems = column.items.map(function (i) { return (__assign(__assign({}, i), { columnId: columnId, menuTarget: menuTarget, itemClickHandler: itemClickHandler, setMenuTarget: setMenuTarget })); });
    return (React.createElement(FixedSizeList, __assign({}, FINDER_COLUMN_SIZES, { itemCount: clusterItems.length + (isUsingPlaceholder ? 1 : 0), outerRef: providedInnerRef, itemData: clusterItems, style: { paddingBottom: '15px' } }), ClusterRow));
});
var getItemStyle = function (isDragging, draggableStyle) {
    return isDragging
        ? __assign({ userSelect: 'none', background: '#ececec' }, draggableStyle) : __assign({ userSelect: 'none' }, draggableStyle);
};
function FinderCluster(_a) {
    var onClick = _a.onClick, item = _a.item, index = _a.index, menuTarget = _a.menuTarget, menuTargetHandler = _a.menuTargetHandler, style = _a.style;
    var clusterId = item.clusterId;
    var isMenuTarget = clusterId === (menuTarget === null || menuTarget === void 0 ? void 0 : menuTarget.id);
    var draggableId = createDraggableId({
        type: DraggableType.Cluster,
        sheetRowPath: item.path,
        tagId: item.tagId,
    });
    return (React.createElement(Draggable, { key: draggableId, draggableId: draggableId, index: index }, function (provided, snapshot) {
        var classes = isMenuTarget ? 'target' : item.isActive ? 'active' : '';
        if (snapshot.combineTargetFor) {
            var combineTargetInfo = parseDraggableId(snapshot.combineTargetFor);
            var combineTargetClusterPath = combineTargetInfo.type === DraggableType.Cluster ? combineTargetInfo.sheetRowPath : '';
            var _a = __read(combineTargetClusterPath.split(':'), 1), clId1 = _a[0];
            var _b = __read(item.path.split(':'), 1), clId2 = _b[0];
            if (clId1 !== clId2) {
                classes += ' dropin';
            }
        }
        if (item.isGenerated) {
            classes += ' generated';
        }
        return (React.createElement("li", __assign({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps, { style: __assign(__assign({}, style), getItemStyle(snapshot.isDragging, provided.draggableProps.style)), className: classes, onClick: onClick, onContextMenu: function (e) {
                e.stopPropagation();
                if (clusterId) {
                    menuTargetHandler(clusterId, item.path, item.isGenerated, item.parentTagId, item.tagId);
                }
            } }),
            React.createElement("span", { onMouseLeave: Manager.closePopover, className: "title" }, item.label),
            item.hasChildren ? React.createElement(IoIosArrowForward, null) : null));
    }));
}
